/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
 */
export interface SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'accountType': SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'companyName': string;
}

export const SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum];


